// extracted by mini-css-extract-plugin
export default {"taskPriorityCellRoot":"TaskPriorityCell_taskPriorityCellRoot__1bjYP"};